(function () {
  'use strict';

  function recommendationFor(use, priority) {
    if (use === 'strokers') return 'strokers';
    if (use === 'anal') return 'anal';
    if (use === 'silicone-toy') return 'sensitive';
    if (use === 'water-play') return 'silicone';
    if (priority === 'gentle') return 'sensitive';
    if (priority === 'lasting') return 'silicone';
    return 'everyday';
  }

  function needsPriority(use) {
    return use === 'partner' || use === 'condoms';
  }

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initializeFinder(section) {
    var form = section.querySelector('[data-lube-finder]');
    if (!form || form.dataset.initialized === 'true') return;

    form.dataset.initialized = 'true';

    var submit = form.querySelector('[data-finder-submit]');
    var priorityStep = form.querySelector('[data-priority-step]');
    var useInputs = form.querySelectorAll('input[name^="use-"]');
    var priorityInputs = form.querySelectorAll('input[name^="priority-"]');
    var finderHeading = section.querySelector('[id^="LubeFinderHeading-"]');
    var showAll = section.querySelector('[data-show-all-paths]');
    var paths = section.querySelectorAll('[data-guide-path]');
    var pathLinks = section.querySelectorAll('[data-path-link]');
    var changeLinks = section.querySelectorAll('[data-change-answers]');

    function selectedInput(prefix) {
      return form.querySelector('input[name^="' + prefix + '"]:checked');
    }

    function selectedValue(prefix) {
      var selected = selectedInput(prefix);
      return selected ? selected.value : '';
    }

    function selectedLabel(prefix) {
      var selected = selectedInput(prefix);
      if (!selected) return '';
      var label = selected.closest('label');
      var text = label ? label.querySelector('span') : null;
      return text ? text.textContent.trim() : '';
    }

    function updateSubmit() {
      var use = selectedValue('use-');
      var priority = selectedValue('priority-');
      submit.disabled = !use || (needsPriority(use) && !priority);
    }

    function updateFinderFlow() {
      var use = selectedValue('use-');
      var requiresPriority = needsPriority(use);

      priorityStep.hidden = !requiresPriority;

      if (!requiresPriority) {
        priorityInputs.forEach(function (input) {
          input.checked = false;
        });
      }

      updateSubmit();
    }

    function showPath(path) {
      paths.forEach(function (item) {
        item.hidden = item.dataset.guidePath !== path;
      });
      showAll.hidden = false;
      showAll.setAttribute('aria-expanded', 'false');
    }

    function hideMatchSummaries() {
      paths.forEach(function (item) {
        var summary = item.querySelector('[data-match-summary]');
        if (summary) summary.hidden = true;
      });
    }

    function showMatchSummary(path) {
      hideMatchSummaries();

      var target = section.querySelector('[data-guide-path="' + path + '"]');
      if (!target) return;

      var summary = target.querySelector('[data-match-summary]');
      var answers = target.querySelector('[data-match-answers]');
      if (!summary || !answers) return;

      var labels = [selectedLabel('use-')];
      var priorityLabel = selectedLabel('priority-');
      if (priorityLabel) labels.push(priorityLabel);

      answers.textContent = 'Based on: ' + labels.join(' + ');
      summary.hidden = false;
    }

    function scrollToPath(path) {
      var target = section.querySelector('[data-guide-path="' + path + '"]');
      if (!target) return;
      target.focus({ preventScroll: true });
      target.scrollIntoView({
        behavior: reducedMotion() ? 'auto' : 'smooth',
        block: 'start'
      });
    }

    useInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        priorityInputs.forEach(function (priorityInput) {
          priorityInput.checked = false;
        });
        updateFinderFlow();
      });
    });

    priorityInputs.forEach(function (input) {
      input.addEventListener('change', updateSubmit);
    });

    pathLinks.forEach(function (link) {
      link.addEventListener('click', function (event) {
        var path = link.dataset.pathLink;
        if (!path) return;
        event.preventDefault();
        hideMatchSummaries();
        showPath(path);
        scrollToPath(path);
      });
    });

    changeLinks.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        hideMatchSummaries();
        finderHeading.focus({ preventScroll: true });
        finderHeading.scrollIntoView({
          behavior: reducedMotion() ? 'auto' : 'smooth',
          block: 'start'
        });
      });
    });

    submit.addEventListener('click', function () {
      var use = selectedValue('use-');
      var priority = selectedValue('priority-');
      if (!use || (needsPriority(use) && !priority)) return;

      var selectedPath = recommendationFor(use, priority);
      showPath(selectedPath);
      showMatchSummary(selectedPath);
      scrollToPath(selectedPath);
    });

    showAll.addEventListener('click', function () {
      paths.forEach(function (item) {
        item.hidden = false;
      });
      showAll.hidden = true;
      showAll.setAttribute('aria-expanded', 'true');
    });

    updateFinderFlow();
  }

  function initializeAll(root) {
    if (root.matches && root.matches('.cyl')) {
      initializeFinder(root);
    }
    root.querySelectorAll('.cyl').forEach(initializeFinder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeAll(document);
    });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();
